var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ec commonborder"},[_c('div',{staticClass:"echarts",attrs:{"id":"ec_bar1"}})])}]

export { render, staticRenderFns }